import { render, staticRenderFns } from "./SubmitDraftTransportRequest.vue?vue&type=template&id=a768101a&scoped=true"
import script from "./SubmitDraftTransportRequest.vue?vue&type=script&lang=ts"
export * from "./SubmitDraftTransportRequest.vue?vue&type=script&lang=ts"
import style0 from "./SubmitDraftTransportRequest.vue?vue&type=style&index=0&id=a768101a&prod&scoped=true&lang=css"
import style1 from "./SubmitDraftTransportRequest.vue?vue&type=style&index=1&id=a768101a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a768101a",
  null
  
)

export default component.exports